
import _ from "lodash"
export default {
  name: "VendorInfo",
  props: {
    info: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {}
}
